import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { MaterialInventoryActions } from "./MaterialInventory.type";

export function* fetchMaterialInventories(action: any): any {
  try {
    console.log('DEBUG: MaterialInventory saga - making API call to:', `${API_BASE_URI}/material-inventory`);
    const response = yield axios.get(
      `${API_BASE_URI}/material-inventory`
    );
    console.log('DEBUG: MaterialInventory saga - response data:', response.data);
    yield put({
      type: MaterialInventoryActions.FETCH_MATERIAL_INVENTORY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.log('DEBUG: MaterialInventory saga - error:', error);
    yield put({
      type: MaterialInventoryActions.FETCH_MATERIAL_INVENTORY_ERROR,
      payload: error,
    });
  }
}

export function* fetchMaterialInventoriesAnalysis(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/material-inventory/analysis?material_id=${action.payload?.material_id}&project_id=${action.payload?.project_id}`
    );
    yield put({
      type: MaterialInventoryActions.FETCH_MATERIAL_INVENTORY_ANALYSIS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialInventoryActions.FETCH_MATERIAL_INVENTORY_ANALYSIS_ERROR,
      payload: error,
    });
  }
}

export function* watcherFetchMaterialInventories() {
  yield takeLatest(
    MaterialInventoryActions.FETCH_MATERIAL_INVENTORY,
    fetchMaterialInventories
  );
}

export function* watcherFetchMaterialInventoriesAnalysis() {
  yield takeLatest(
    MaterialInventoryActions.FETCH_MATERIAL_INVENTORY_ANALYSIS,
    fetchMaterialInventoriesAnalysis
  );
}
